import { useState } from "react";
import {
  ChevronDown,
  ChevronUp,
  PlusLg,
  ThreeDotsVertical,
} from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import FormButtonDisable from "../../Components/Buttons/FormButtonDisable";
import InputFiled from "../../Components/FormTag/InputFiled";
import {
  Productivity,
  ProductivityInbound,
  ProductivityOutbound,
} from "./model/Client.type";

import { useNavigate } from "react-router-dom";
import FormButton from "../../Components/Buttons/FormButton";
import FormSelect from "../../Components/FormTag/FormSelect";
import Table, { Column } from "../../Components/Tables/Table";
import {
  inboundEntityList,
  inboundGoalTypeList,
  inboundIntervalList,
} from "../../Data/dropdownDataList";
import { NUMBER_REGEX } from "../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../Shared/Helper/ValidationMessage";

interface ClientProductivityProps {
  handleNext: () => void;
}

export default function ClientProductivity(props: ClientProductivityProps) {
  const navigation = useNavigate();
  const { handleNext } = props;
  const [inBoundData, setInBoundData] = useState<ProductivityInbound>(
    new ProductivityInbound()
  );
  const [inBoundList, setInBoundList] = useState<ProductivityInbound[]>([]);
  const [outBoundData, setOutBoundData] = useState<ProductivityOutbound>(
    new ProductivityOutbound()
  );
  const [outBoundList, setOutBoundList] = useState<ProductivityOutbound[]>([]);
  const [productivity, setProductivity] = useState<Productivity>();
  const {
    handleSubmit: handleSubmitInbound,
    register: registerInbound,
    control: controlInbound,
    reset: resetInbound,
    formState: { errors: errorsInbound },
  } = useForm<ProductivityInbound>({
    defaultValues: inBoundData,
  });
  const {
    handleSubmit: handleSubmitOutbound,
    register: registerOutbound,
    control: controlOutbound,
    reset: resetOutbound,
    formState: { errors: errorsOutbound },
  } = useForm<ProductivityOutbound>({
    defaultValues: outBoundData,
  });
  const handelEditAction = (data: any) => {};
  const handelInactiveAction = (data: any) => {};
  const handelDeleteAction = (data: any) => {};

  const inColumns: Column[] = [
    {
      name: "S. No",
      selector: (row: { in_serialNumber: number }) => row.in_serialNumber,
    },
    {
      name: "Entity",
      selector: (row: { in_entity: string }) =>
        inboundEntityList.find((en) => en.value === row.in_entity)?.label,
    },
    {
      name: "Goal Type",
      selector: (row: { in_goalType: string }) =>
        inboundGoalTypeList.find((gl) => gl.value === row.in_goalType)?.label,
    },
    {
      name: "Interval",
      selector: (row: { in_interval: string }) =>
        inboundIntervalList.find((ii) => ii.value === row.in_interval)?.label,
    },
    {
      name: "Quantity",
      selector: (row: { in_quantity: string }) => row.in_quantity,
    },
    {
      name: "",
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelEditAction(row)}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelInactiveAction(row)}
            >
              Inactive
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={handelDeleteAction}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];
  const outColumns: Column[] = [
    {
      name: "S. No",
      selector: (row: { out_serialNumber: number }) => row.out_serialNumber,
    },
    {
      name: "Entity",
      selector: (row: { out_entity: string }) =>
        inboundEntityList.find((en) => en.value === row.out_entity)?.label,
    },
    {
      name: "Goal Type",
      selector: (row: { out_goalType: string }) =>
        inboundGoalTypeList.find((gl) => gl.value === row.out_goalType)?.label,
    },
    {
      name: "Interval",
      selector: (row: { out_interval: string }) =>
        inboundIntervalList.find((ii) => ii.value === row.out_interval)?.label,
    },
    {
      name: "Quantity",
      selector: (row: { out_quantity: string }) => row.out_quantity,
    },
    {
      name: "",
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelEditAction(row)}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={() => handelInactiveAction(row)}
            >
              Inactive
            </li>
            <li
              className="cursor-pointer ms-3 mb-1"
              onClick={handelDeleteAction}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];

  const saveInboundProductivity: SubmitHandler<ProductivityInbound> = (
    data
  ) => {
    console.log(data);

    const newData = {
      in_serialNumber: inBoundList.length + 1,
      in_entity: data.in_entity,
      in_goalType: data.in_goalType,
      in_interval: data.in_interval,
      in_quantity: data.in_quantity,
    };
    setInBoundList([...inBoundList, newData]);
    resetInbound(new ProductivityInbound());
  };
  const saveOutboundProductivity: SubmitHandler<ProductivityOutbound> = (
    data
  ) => {
    const newData = {
      out_serialNumber: outBoundList.length + 1,
      out_entity: data.out_entity,
      out_goalType: data.out_goalType,
      out_interval: data.out_interval,
      out_quantity: data.out_quantity,
    };
    setOutBoundList([...outBoundList, newData]);
    resetOutbound(new ProductivityOutbound());
  };
  const [collapseStates, setCollapseStates] = useState<boolean[]>([
    true,
    false,
  ]);

  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };
  const handelCancelBtn = () => {
    navigation("/account/client/overview/grid-view");
  };
  const handelSubmitData = () => {
    setProductivity((item) => ({
      ...item,
      inBound: inBoundList,
      outBound: outBoundList,
    }));
    handleNext();
  };
  return (
    <div>
      <div className="d-flex flex-column min-height-62">
        <div
          key={`accordionPanelInbound`}
          className="my-2 bg-white rounded py-3"
          id={`accordionPanelInboundHeader`}
        >
          <div className="d-flex justify-content-between align-item-center px-3">
            <div className="align-self-center">
              <h5 className="fw-bold mb-0">Inbound</h5>
            </div>
            <div className="align-self-center">
              <span
                className="badge rounded-pill sph-text-bg-light-grey cursor-pointer"
                onClick={() => toggleCollapse(0)}
              >
                {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
              </span>
            </div>
          </div>

          {collapseStates[0] && (
            <>
              <div
                className="mt-2 px-3 accordion-collapse collapse show"
                id={`accordionCollapseInboundBody`}
              >
                <div className="d-flex ps-4 mb-4 pt-2 col-12 justify-content-between">
                  <div className="col-10 d-flex">
                    <div className="col-3 px-2">
                      <label className="fw-medium">Entity</label>
                      <div className="mt-1">
                        <FormSelect
                          name="in_entity"
                          control={controlInbound}
                          optionList={inboundEntityList}
                          className="form-control p-0"
                          placeholder="Select"
                          errors={errorsInbound.in_entity}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-3 px-2">
                      <label className="fw-medium">Goal Type</label>
                      <div className="mt-1">
                        <FormSelect
                          name="in_goalType"
                          control={controlInbound}
                          optionList={inboundGoalTypeList}
                          className="form-control p-0"
                          placeholder="Select"
                          errors={errorsInbound.in_goalType}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-3 px-2">
                      <label className="fw-medium">Interval</label>
                      <div className="mt-1">
                        <FormSelect
                          name="in_interval"
                          control={controlInbound}
                          optionList={inboundIntervalList}
                          className="form-control p-0"
                          placeholder="Select"
                          errors={errorsInbound.in_interval}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-3 px-2">
                      <label className="fw-medium">Quantity</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={registerInbound}
                          name="in_quantity"
                          required={true}
                          errors={errorsInbound.in_quantity}
                          pattern={{
                            type: NUMBER_REGEX,
                            message: PATTERN_ERR_MSG,
                          }}
                          className="form-control"
                          placeholder="Enter Quantity"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex mb-2 col-2 mt-4">
                    <FormButtonDisable
                      className="sph-btn ms-3 d-fkex align-items-center "
                      handleClick={handleSubmitInbound(saveInboundProductivity)}
                      disabled={false}
                    >
                      <PlusLg className="mb-1" /> Add
                    </FormButtonDisable>
                  </div>
                </div>
                {inBoundList.length !== 0 ? (
                  <Table columns={inColumns} data={inBoundList} customClassName="transferDetailsTable table-striped sph-table" />
                ) : (
                  <></>
                )}
              </div>
            </>
          )}
        </div>
        <div
          key={`accordionPanelOutbound`}
          className="my-2 bg-white rounded py-3"
          id={`accordionPanelOutboundHeader`}
        >
          <div className="d-flex justify-content-between align-item-center px-3">
            <div className="align-self-center">
              <h5 className="fw-bold mb-0">Outbound</h5>
            </div>
            <div className="align-self-center">
              <span
                className="badge rounded-pill sph-text-bg-light-grey cursor-pointer"
                onClick={() => toggleCollapse(1)}
              >
                {collapseStates[1] ? <ChevronUp /> : <ChevronDown />}
              </span>
            </div>
          </div>
          {collapseStates[1] && (
            <>
              <div
                className="mt-2 px-3 accordion-collapse collapse show"
                id={`accordionCollapseInboundBody`}
              >
                <div className="d-flex ps-4 mb-4 pt-2 col-12 justify-content-between">
                  <div className="col-10 d-flex">
                    <div className="col-3 px-2">
                      <label className="fw-medium">Entity</label>
                      <div className="mt-1">
                        <FormSelect
                          name="out_entity"
                          control={controlOutbound}
                          optionList={inboundEntityList}
                          className="form-control p-0"
                          placeholder="Select"
                          errors={errorsOutbound.out_entity}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-3 px-2">
                      <label className="fw-medium">Goal Type</label>
                      <div className="mt-1">
                        <FormSelect
                          name="out_goalType"
                          control={controlOutbound}
                          optionList={inboundGoalTypeList}
                          className="form-control p-0"
                          placeholder="Select"
                          errors={errorsOutbound.out_goalType}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-3 px-2">
                      <label className="fw-medium">Interval</label>
                      <div className="mt-1">
                        <FormSelect
                          name="out_interval"
                          control={controlOutbound}
                          optionList={inboundIntervalList}
                          className="form-control p-0"
                          placeholder="Select"
                          errors={errorsOutbound.out_interval}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-3 px-2">
                      <label className="fw-medium">Quantity</label>
                      <div className="mt-1">
                        <InputFiled
                          type="text"
                          register={registerOutbound}
                          name="out_quantity"
                          required={true}
                          errors={errorsOutbound.out_quantity}
                          pattern={{
                            type: NUMBER_REGEX,
                            message: PATTERN_ERR_MSG,
                          }}
                          className="form-control"
                          placeholder="Enter Quantity"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex mb-2 col-2 margin-top-28">
                    <FormButtonDisable
                      className="sph-btn ms-3 d-fkex align-items-center "
                      handleClick={handleSubmitOutbound(
                        saveOutboundProductivity
                      )}
                      disabled={false}
                    >
                      <PlusLg className="mb-1" /> Add
                    </FormButtonDisable>
                  </div>
                </div>
                {outBoundList.length !== 0 ? (
                  <Table columns={outColumns} data={outBoundList} />
                ) : (
                  <></>
                )}
              </div>
            </>
          )}
        </div>
        <div className="my-2 bg-white rounded py-3 mt-auto">
          <div className="d-flex flex-row-reverse ">
            <FormButton className="sph-btn me-4" handleClick={handelSubmitData}>
              Next
            </FormButton>
            <FormButton
              className="sph-btn sph-shift me-4"
              handleClick={handelCancelBtn}
            >
              Cancel
            </FormButton>
          </div>
        </div>
      </div>
    </div>
  );
}
